import React, { ChangeEvent,  useState } from "react";
import Webcamera from "./Webcamera";
import camera from "../../assets/icons/camera.png";
import { useParams } from "react-router-dom";
function ImputImage({
  name,
  type,
  label,
  errors,
  errormessage,
  placeholder,
  defaultValue,
  imageback,
  onChange,
  value,
  isDisable,
}: any) {
  const [opencamera, setopencamera] = useState(false);
  const [images, setimages] = useState<string | null>(null);
  const [, setcaptureImage] = useState<string | null>(null);
  const { ID } = useParams();

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setimages(event.target.value);

    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setcaptureImage(result);
      onChange({
        target: { name: name || "", value: result }, // Provide a default value for 'name'
      });
    };
    reader.readAsDataURL(file);
  };
  const handleWebcam = (e: any) => {
    onChange({
      target: { name: name || "", value: e }, // Provide a default value for 'name'
    });
  };
  return (
    <>
      <div className="input_webcamImage">
        <label htmlFor=""> Patient Image</label>
        <div className="selection_option">
          <div className="from_file">
            <label>Select Image</label>
            <input
              disabled={isDisable}
              value={images ?? ""}
              type={type}
              accept="image/*"
              onChange={handleImageChange}
            />
          </div>
          <div className="from_webcam">
            <label> Open Webcam</label>
            <div
              onClick={() => {
                !isDisable && setopencamera(true);
              }}
            >
              <img src={camera} alt="" />
            </div>
          </div>
        </div>
        <div className="image_contaier">
          <img
            src={
              value
                ? ID
                  ? value?.length > 400
                    ? value
                    : `${process.env.REACT_APP_API}${value}`
                  : value
                : camera
            }
            alt=""
          />
        </div>
      </div>

      {opencamera && (
        <Webcamera
          handleWebcam={handleWebcam}
          setcaptureImage={setcaptureImage}
          setopencamera={setopencamera}
        />
      )}
    </>
  );
}

export default ImputImage;
